/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserIdResponse
 */
export interface GetUserIdResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserIdResponse
     */
    userId: string;
}

export function GetUserIdResponseFromJSON(json: any): GetUserIdResponse {
    return GetUserIdResponseFromJSONTyped(json, false);
}

export function GetUserIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserIdResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

export function GetUserIdResponseToJSON(value?: GetUserIdResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
    };
}


